import mrpStyles from './../mrp.json'

export default {
  color: mrpStyles.colors.SecondaryGreyMetal,
  iconColor: mrpStyles.colors.SecondaryGreySteel,
  dashLength: 16,
  dashHeight: 2
}
